export default {"src":"/_next/static/media/lacrosse.8bbec2d5.svg","height":55,"width":55,"blurWidth":0,"blurHeight":0};